// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__gh-4x","empty":"ModalGraph_empty__2LzwH"};